import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const FilterButtonComponent = ({ onClick }) => {
    const { t } = useTranslation();
    const handleClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
        onClick(e);
    };
    return (
        <button
            type="button"
            onClick={handleClick}
            className="btn btn-light px-4 ml-2"
        >
            {t("filter.filter")}
        </button>
    );
};

FilterButtonComponent.propTypes = {
    onClick: PropTypes.func.isRequired
};

export default React.memo(FilterButtonComponent);
